import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { MainButton } from '@/shared/ui/Buttons/MainButton';

const ActionCall = () => {
  const navigate = useNavigate();
  const onSubmit = () => {
    navigate('/auth');
  };
  return (
    <section className={cn('section', styles.actionCall)}>
      <div className={cn('container', styles.container)}>
        <div className={styles.titleWrapper}>
          <h2 className={styles.title}>
            <FormattedMessage
              defaultMessage="Одобряем микрокредиты на самых выгодных условиях в течение {value}"
              values={{
                value: (
                  <span className={styles.markText}>
                    <FormattedMessage defaultMessage="10 минут" />
                  </span>
                ),
              }}
            />
          </h2>
          <h3 className={styles.subtitle}>
            <FormattedMessage defaultMessage="Получите деньги на карту уже сегодня" />
          </h3>
        </div>
        <div className={styles.buttonWrapper}>
          <MainButton
            id="home-page-action-call"
            text={<FormattedMessage defaultMessage="Получить деньги" />}
            onClick={onSubmit}
          />
        </div>
      </div>
    </section>
  );
};

export default ActionCall;
